import { PROM_MAINNET_CHAIN_ID, promMainnet } from "config/default";
import type { ChainId } from "config/wagmi";
import { zeroAddress } from "ethereumjs-util";
import { bsc, mainnet, optimism, arbitrum, polygon } from "wagmi/chains";

export const tokenList = [
  // TODO: Refactor
  {
    symbol: "PROM",
    name: "Prom",
    address: zeroAddress(),
    chainId: promMainnet.id,
    decimals: 18,
    logoURI:
      "https://assets-cdn.trustwallet.com/blockchains/ethereum/assets/0xfc82bb4ba86045Af6F327323a46E80412b91b27d/logo.png",
  },
];

const pics = {
  prom: "https://raw.githubusercontent.com/trustwallet/assets/d893e916c6947b6bdbf1661fc7fca13430584788/blockchains/ethereum/assets/0xfc82bb4ba86045Af6F327323a46E80412b91b27d/logo.png",
  usdc: "https://raw.githubusercontent.com/trustwallet/assets/77ef0d99eaf03aa766d64f7bd02eeb41c3b1604d/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
  usdt: "https://raw.githubusercontent.com/trustwallet/assets/926ed75410329f223a8ce6a9bc8b288d1dd6c810/blockchains/ethereum/assets/0xb977ee318010A5252774171494a1bCB98E7fab65/logo.png",
};

type BridgeTokenConfig = {
  symbol: string;
  name: string;
  routerAddress: string;
  address: string;
  chainId: ChainId | number;
  decimals: number;
  logoURI: string;
  networksTo: ChainId[] | number[];
};

type BridgeTokenConfigs = {
  [chainId: ChainId]: BridgeTokenConfig[];
};

export const bridgeTokenConfig: BridgeTokenConfigs = {
  [promMainnet.id]: [
    {
      symbol: "PROM",
      name: "Prom",
      routerAddress: "0xc1f4b896B94bd57dEfB7b6e630Bb91995b86CbAC",
      address: zeroAddress(),
      chainId: promMainnet.id,
      decimals: 18,
      logoURI: pics.prom,
      networksTo: [bsc.id],
    },
    {
      symbol: "PROM",
      name: "Prom",
      routerAddress: "",
      address: zeroAddress(),
      chainId: promMainnet.id,
      decimals: 18,
      logoURI: pics.prom,
      networksTo: [],
    },
    {
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0x7e942605B5028E3B751dBB5Ef8afC5CF85a5A7eD",
      address: "0x7e942605B5028E3B751dBB5Ef8afC5CF85a5A7eD",
      chainId: promMainnet.id,
      decimals: 6,
      logoURI: pics.usdt,
      networksTo: [mainnet.id, polygon.id, optimism.id, arbitrum.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0xd9c95e2ad330E11D7Dfa58f18504049f625E955e",
      address: "0xd9c95e2ad330E11D7Dfa58f18504049f625E955e",
      chainId: promMainnet.id,
      decimals: 6,
      logoURI: pics.usdc,
      networksTo: [mainnet.id, polygon.id, optimism.id, arbitrum.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0x451c22b06a5f38a43641f6910834C90f3619cEb9",
      address: "0x451c22b06a5f38a43641f6910834C90f3619cEb9",
      chainId: bsc.id,
      decimals: 18,
      logoURI: pics.usdc,
      networksTo: [bsc.id],
    },
    {
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0x6064C9028d069a7822d30EF17065A57524A5FcAb",
      address: "0x6064C9028d069a7822d30EF17065A57524A5FcAb",
      chainId: promMainnet.id,
      decimals: 18,
      logoURI: pics.usdt,
      networksTo: [bsc.id],
    },
  ],
  [mainnet.id]: [
    {
      symbol: "PROM",
      name: "Prom",
      routerAddress: "",
      address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
      chainId: mainnet.id,
      decimals: 18,
      logoURI: pics.prom,
      networksTo: [],
    },
    {
      symbol: "PROM",
      name: "Prom",
      routerAddress: "0x25C147Bd61bdaB6ce5A1Ae4939d2765092e0e2F8",
      address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
      chainId: mainnet.id,
      decimals: 18,
      logoURI: pics.prom,
      networksTo: [bsc.id],
    },
    {
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0xBA18df45758a09647F1902a06807844EA5DD47b4",
      address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      chainId: mainnet.id,
      decimals: 6,
      logoURI: pics.usdt,
      networksTo: [promMainnet.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0x424712Bec7c94a0F804c50F77B641A24F33A138e",
      address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      chainId: promMainnet.id,
      decimals: 6,
      logoURI: pics.usdc,
      networksTo: [promMainnet.id],
    },
  ],
  [bsc.id]: [
    {
      // PROM Token | ETH Network - ETH<>BSC
      symbol: "PROM",
      name: "PROM",
      routerAddress: "0x700b9322F6Cce0c8EFF4754bE9AcE88Ce6582821",
      address: "0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5",
      chainId: bsc.id,
      decimals: 18,
      logoURI:
        "https://raw.githubusercontent.com/trustwallet/assets/d893e916c6947b6bdbf1661fc7fca13430584788/blockchains/ethereum/assets/0xfc82bb4ba86045Af6F327323a46E80412b91b27d/logo.png",
      networksTo: [promMainnet.id],
    },
    {
      // PROM Token | BSC Network - ETH<>BSC
      symbol: "PROM",
      name: "PROM",
      routerAddress: "0xA83e1e21e82038e425e7a47aD7c2e059D7F1cae6",
      address: "0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5",
      chainId: bsc.id,
      decimals: 18,
      logoURI:
        "https://raw.githubusercontent.com/trustwallet/assets/d893e916c6947b6bdbf1661fc7fca13430584788/blockchains/ethereum/assets/0xfc82bb4ba86045Af6F327323a46E80412b91b27d/logo.png",
      networksTo: [mainnet.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0xb4aF6757691573f0acAbA35A724a8E0EE049aB5a",
      address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      chainId: promMainnet.id,
      decimals: 18,
      logoURI: pics.usdc,
      networksTo: [promMainnet.id],
    },
    {
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0xCf2D543345728da295CC5d3A3d54B117979643f8",
      address: "0x55d398326f99059fF775485246999027B3197955",
      chainId: bsc.id,
      decimals: 18,
      logoURI: pics.usdt,
      networksTo: [promMainnet.id],
    },
  ],
  [optimism.id]: [
    {
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0xE9ef49e77c9f4751fBb0176836da70D062bBae02",
      address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
      chainId: optimism.id,
      decimals: 6,
      logoURI: pics.usdt,
      networksTo: [promMainnet.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0xEa1A15ed2710f860a38091877c6A84b18206b501",
      address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
      chainId: promMainnet.id,
      decimals: 6,
      logoURI: pics.usdc,
      networksTo: [promMainnet.id],
    },
  ],
  [arbitrum.id]: [
    {
      // USDT | Arbitrum => PromNetwork
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0xB9D49E18c69628C6D6B12Ab06F1918C4c4fe9546",
      address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
      chainId: arbitrum.id,
      decimals: 6,
      logoURI: pics.usdt,
      networksTo: [promMainnet.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0x736f1150203E88E6aBA183f216A4a51b6ca12156",
      address: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
      chainId: arbitrum.id,
      decimals: 6,
      logoURI: pics.usdc,
      networksTo: [promMainnet.id],
    },
  ],
  [polygon.id]: [
    {
      // USDT | Arbitrum => PromNetwork
      symbol: "USDT",
      name: "USDT Tether",
      routerAddress: "0x009eA8aBe4CE04fFA4A2b2Ec62cBAC859fc48B19",
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      chainId: polygon.id,
      decimals: 6,
      logoURI: pics.usdt,
      networksTo: [promMainnet.id],
    },
    {
      symbol: "USDC",
      name: "USDC",
      routerAddress: "0x93b637AEA6a0dF51E8E24E49C62da34f616491c5",
      address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
      chainId: polygon.id,
      decimals: 6,
      logoURI: pics.usdc,
      networksTo: [promMainnet.id],
    },
  ],
};

export const DESTINATION_NETWORK = {
  [mainnet.id]: 0,
  [promMainnet.id]: 1,
};

export const DESTINATION_NETWORK_BY_VALUE = {
  [0]: {
    chain: mainnet,
    explorer: "https://eth.blockscout.com/",
  },
  [1]: {
    chain: promMainnet,
    explorer: "https://prom-blockscout.eu-north-2.gateway.fm/",
  },
};

export const defaultSelectedToken = {
  address: tokenList[0].address,
  chainId: tokenList[0].chainId,
};

export const chainNamesById = {
  [PROM_MAINNET_CHAIN_ID]: "prom",
  [bsc.id]: "bsc",
  [mainnet.id]: "ethereum",
  [optimism.id]: "optimism",
  [polygon.id]: "polygon",
  [arbitrum.id]: "arbitrum",
};

export const timeByChainId = {
  [PROM_MAINNET_CHAIN_ID]: {
    [bsc.id]: "1.5 minutes",
    [mainnet.id]: "25 hours",
    [optimism.id]: "2 minutes",
    [polygon.id]: "2 minutes",
    [arbitrum.id]: "2 minutes",
    [PROM_MAINNET_CHAIN_ID]: "0.00s",
  },
  [bsc.id]: {
    [PROM_MAINNET_CHAIN_ID]: "1.5 minutes",
    [mainnet.id]: "3 minutes",
    [optimism.id]: "0.00s",
    [polygon.id]: "0.00s",
    [arbitrum.id]: "0.00s",
    [bsc.id]: "0.00s",
  },
  [mainnet.id]: {
    [bsc.id]: "18 minutes",
    [PROM_MAINNET_CHAIN_ID]: "18 minutes",
    [optimism.id]: "0.00s",
    [polygon.id]: "0.00s",
    [arbitrum.id]: "0.00s",
    [mainnet.id]: "0.00s",
  },
  [optimism.id]: {
    [bsc.id]: "0.00s",
    [PROM_MAINNET_CHAIN_ID]: "2 minutes",
    [mainnet.id]: "0.00s",
    [polygon.id]: "0.00s",
    [arbitrum.id]: "0.00s",
    [optimism.id]: "0.00s",
  },
  [polygon.id]: {
    [optimism.id]: "0.00s",
    [bsc.id]: "0.00s",
    [PROM_MAINNET_CHAIN_ID]: "2 minutes",
    [mainnet.id]: "0.00s",
    [arbitrum.id]: "0.00s",
    [polygon.id]: "0.00s",
  },
  [arbitrum.id]: {
    [optimism.id]: "0.00s",
    [bsc.id]: "0.00s",
    [PROM_MAINNET_CHAIN_ID]: "2 minutes",
    [mainnet.id]: "0.00s",
    [polygon.id]: "0.00s",
    [arbitrum.id]: "0.00s",
  },
} as const;
